/**
 * 相机当前注视点的共享 Vector3 实例。
 * FlyingCamera 会持续修改它，Postprocessing 用同一个对象更新景深焦点，
 * 从而保证相机朝向与景深目标保持一致，同时避免每帧创建新对象。
 */
import { Vector3 } from 'three';
import { data } from './data';

export const cameraLookAtVec = new Vector3(
    // 初始值使用第一章节的注视点，避免首帧出现无效焦点。
    data[1].cameraLookAt.x,
    data[1].cameraLookAt.y,
    data[1].cameraLookAt.z,
);
